import { history } from "../../support/HttpService";

export const GenericErrors = (error) => {
    if (error.response.status === 401 || error.response.status === 403) {
        history.navigate('/alta1a1/errorbackend');
    } else if (error.response.status === 404 ) {
        history.navigate('/alta1a1/errorbackend');
    } else if (error.response.status === 500 || error.response.status === 429) {
        history.navigate('/alta1a1/errorbackend');
    }
}